// removed by extract-text-webpack-plugin
module.exports = {"text800":"_2eRFdNTfB5e_kSVcsBGw2Q","text700":"_2QiIwwFnMycMvO3sHKm2VH","text600":"h-ibTQdF3mjB5iB2QVHsj","text500":"_1Rdx8xl7JQHCoz0zSFI5PE","text400":"Sl5LZXNGQKIiV6lAxoZkb","text300":"JknMIogk7latc5CD1Kiar","text200":"_2qCj_JeSEJc0zSVGVQ3pJ_","textParagraph":"_2k8rrgZxjJo14D9SrCjb1n","crimp":"_3SbkNJ5JfMPziWv8UOsL2S","trim":"_67-q41uAnc1WTElCmLOar","flexCenter":"_2Z4OcGhsl-Ux3PWIYD9--g","hideTextOverflow":"_1Luc1JYrevIBgg9t20td9B","marginPageMainContent":"_1-ea_KyfRKg0hsh0eiAI7J","message":"_1Twp1dF5Qz5KaTB8hmnQ9e"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageErrorNotFound/styles.scss
// module id = 844
// module chunks = 0